import { sendCreateWorkspaceEvent } from '../index';
import { EventAdapter } from './EventAdapter';

export class CreateWorkspaceEventAdapter extends EventAdapter {
  protected amplitudeEventFunction = sendCreateWorkspaceEvent;
  protected intercomEventKey = 'create_workspace';

  constructor(settings: { workspace_id: string }) {
    super();

    try {
      this.eventData = settings;
    } catch (err) {
      console.error('Error parsing analytics data', err);
    }
  }
}
